const helperRoute = {
  MAIN_HELPER: '/bantuan',
}

export default helperRoute
